export const schema = {
  id: 'candu',
  info: { name: 'Candu Styleguide', version: '18/03/2020' },
  enums: [
    {
      id: 'Colors',
      values: [
        { value: 'primary', name: 'Primary' },
        { value: 'secondary', name: 'Secondary' },
        { value: 'tertiary', name: 'Tertiary' },
        { value: 'warning', name: 'Warning' },
        { value: 'danger', name: 'Danger' },
      ],
    },
    { id: 'DismissBehaviour', values: [{ value: 'minimize' }, { value: 'dismiss' }] },
    {
      id: 'Language',
      values: [
        { value: 'markup' },
        { value: 'html' },
        { value: 'xml' },
        { value: 'css' },
        { value: 'javascript' },
        { value: 'shell' },
        { value: 'cpp' },
        { value: 'java' },
        { value: 'jsx' },
        { value: 'tsx' },
        { value: 'scala' },
      ],
    },
    {
      id: 'Outlines',
      values: [
        { value: 'solid', name: 'Solid' },
        { value: 'light', name: 'Light' },
      ],
    },
    {
      id: 'Sizes',
      values: [
        { value: 'xs', name: 'Extra-Small' },
        { value: 'sm', name: 'Small' },
        { value: 'md', name: 'Medium' },
        { value: 'lg', name: 'Large' },
        { value: 'xl', name: 'Extra-Large' },
      ],
    },
    {
      id: 'Typography',
      values: [
        { value: 'H1', name: 'Header 1' },
        { value: 'H2', name: 'Header 2' },
        { value: 'H3', name: 'Header 3' },
        { value: 'H4', name: 'Header 4' },
        { value: 'H5', name: 'Header 5' },
        { value: 'H6', name: 'Header 6' },
        { value: 'P', name: 'Paragraph' },
      ],
    },
    {
      id: 'Lists',
      values: [
        { value: 'OL', name: 'Numbered List' },
        { value: 'UL', name: 'Bullet List' },
      ],
    },
    {
      id: 'Intents',
      values: [
        { value: 'default', name: 'Default' },
        { value: 'success', name: 'Success' },
        { value: 'active', name: 'Active' },
        { value: 'warning', name: 'Warning' },
        { value: 'danger', name: 'Danger' },
      ],
    },
    {
      id: 'CheckListScopes',
      values: [
        { value: 'user', name: 'User' },
        { value: 'account', name: 'Account' },
      ],
    },
    {
      id: 'AspectRatios',
      values: [
        { value: '16:9', name: '16:9' },
        { value: '4:3', name: '4:3' },
        { value: '16:10', name: '16:10' },
        { value: '2:1', name: '2:1' },
      ],
    },
    { id: 'InputType', values: [{ value: 'text' }, { value: 'number' }, { value: 'email' }] },
    { id: 'StepType', values: [{ value: 'success' }] },
  ],
  components: [
    {
      type: 'Alert',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'intent',
          fieldType: { enumId: 'Intents', isRequired: true, defaultValue: 'default', type: 'Enum' },
          name: 'Intent',
        },
        {
          id: 'outline',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Outline',
          editingMode: 'Custom',
        },
        {
          id: 'hasDescription',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'Add Description',
        },
        { id: 'title', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'description',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'Badge',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'color',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Colors',
          editingMode: 'Custom',
        },
        {
          id: 'outline',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Outline',
          editingMode: 'Custom',
        },
        { id: 'children', fieldType: { isRequired: false, type: 'String' } },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'Button',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'color',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Colors',
          editingMode: 'Custom',
        },
        {
          id: 'size',
          fieldType: { enumId: 'Sizes', isRequired: true, defaultValue: 'md', type: 'Enum' },
          name: 'Sizes',
          editingMode: 'Custom',
        },
        { id: 'children', fieldType: { isRequired: false, type: 'String' } },
        {
          id: 'outline',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Outline',
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
      actions: ['OnClick'],
    },
    {
      type: 'CheckList',
      category: 'Container',
      location: 'Internal',
      name: 'CheckList',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'slug', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'title', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'successScreen',
          fieldType: { isRequired: false, type: 'Node' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'CheckListGroup',
      category: 'Container',
      location: 'Internal',
      name: 'CheckList',
      custom: [{ id: 'groupId', fieldType: { isRequired: false, type: 'String' } }],
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'title',
          fieldType: { isRequired: true, type: 'String' },
          name: 'Title',
          editingMode: 'Custom',
        },
        {
          id: 'scope',
          fieldType: {
            enumId: 'CheckListScopes',
            isRequired: false,
            defaultValue: 'user',
            type: 'Enum',
          },
          name: 'Scope',
          editingMode: 'Custom',
        },
        {
          id: 'scopeTrait',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'CheckListItem',
      category: 'Container',
      location: 'Internal',
      name: 'CheckList Item',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'title', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'expiresAt',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'assignee', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'Columns',
      category: 'Layout',
      location: 'Internal',
      name: 'Columns',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'Column',
      category: 'Layout',
      location: 'Internal',
      name: 'Column',
      custom: [
        { id: 'width', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'id', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'EmbedContent',
      category: 'Atomic',
      location: 'Leaf',
      name: 'Embed',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'slug', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    { type: 'ConditionalView', category: 'Layout', location: 'Internal', name: 'Conditional View' },
    {
      type: 'ConditionalViewOption',
      category: 'Layout',
      location: 'Internal',
      name: 'Conditional View Option',
      props: [
        { id: 'name', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'Flow',
      category: 'Layout',
      location: 'Internal',
      name: 'Flow',
      props: [
        { id: 'stateId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'FlowStep',
      category: 'Layout',
      location: 'Internal',
      name: 'Flow Step',
      props: [
        { id: 'stepId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'IFrame',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'src', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'height', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'width', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'allowFullScreen',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'Allow full screen',
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'EmbedPortal',
      category: 'Atomic',
      location: 'Leaf',
      name: 'Embed',
      props: [
        { id: 'slug', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'EmbedTutorial',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        { id: 'id', fieldType: { isRequired: false, type: 'Number' }, editingMode: 'Custom' },
        { id: 'slug', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'Image',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'src', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'height', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'width', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'naturalHeight',
          fieldType: { isRequired: false, type: 'Number' },
          editingMode: 'Custom',
        },
        {
          id: 'naturalWidth',
          fieldType: { isRequired: false, type: 'Number' },
          editingMode: 'Custom',
        },
        { id: 'alt', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'cropBottom',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'cropLeft', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'cropRight',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'cropTop', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
      actions: ['OnClick'],
    },
    {
      type: 'Player',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'src', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'title', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'ariaLabel',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'height', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'width', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'aspectRatio',
          fieldType: {
            enumId: 'AspectRatios',
            isRequired: false,
            defaultValue: '16:9',
            type: 'Enum',
          },
          name: 'AspectRatios',
          editingMode: 'Custom',
        },
      ],
    },
    { type: 'Document', category: 'Layout', location: 'Internal', name: 'Document' },
    {
      type: 'Collection',
      category: 'Layout',
      location: 'Internal',
      name: 'Collection',
      props: [
        {
          id: 'collectionId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'maxRecords',
          fieldType: { isRequired: false, type: 'Number' },
          editingMode: 'Custom',
        },
        { id: 'filterId', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    { type: 'CollectionItem', category: 'Layout', location: 'Internal', name: 'Collection Item' },
    {
      type: 'RichText',
      category: 'Typography',
      location: 'Internal',
      name: 'Text',
      props: [
        {
          id: 'hasCopy',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'hasCopy',
          editingMode: 'Custom',
        },
      ],
      actions: ['OnClick'],
    },
    { type: 'Spacing', category: 'Atomic', location: 'Leaf' },
    {
      type: 'Text',
      category: 'Typography',
      location: 'Leaf',
      custom: [
        { id: 'marks', fieldType: { isRequired: false, type: 'Custom' }, editingMode: 'Custom' },
      ],
      props: [{ id: 'children', fieldType: { isRequired: false, type: 'String' } }],
    },
    {
      type: 'Typography',
      category: 'Typography',
      location: 'Internal',
      custom: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'variant',
          fieldType: { isRequired: true, defaultValue: 'P', type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'variation',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'Link',
      category: 'Typography',
      location: 'Internal',
      props: [{ id: 'href', fieldType: { isRequired: false, type: 'String' } }],
    },
    {
      type: 'Card',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'isDismissible',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'Dismissible',
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
      actions: ['OnClick'],
    },
    { type: 'View', category: 'Layout', location: 'Internal', name: 'Layout' },
    {
      type: 'Code',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'language',
          fieldType: {
            enumId: 'Language',
            isRequired: false,
            defaultValue: 'javascript',
            type: 'Enum',
          },
          name: 'Language',
        },
        { id: 'children', fieldType: { isRequired: false, type: 'String' } },
      ],
    },
    {
      type: 'List',
      category: 'Layout',
      location: 'Internal',
      custom: [{ id: 'variant', fieldType: { enumId: 'Lists', isRequired: false, type: 'Enum' } }],
    },
    { type: 'ListItem', category: 'Layout', location: 'Internal' },
    {
      type: 'Tab',
      category: 'Layout',
      location: 'Internal',
      props: [{ id: 'label', fieldType: { isRequired: false, type: 'String' }, name: 'Label' }],
    },
    { type: 'TabGroup', category: 'Container', location: 'Internal', name: 'Tabs' },
    {
      type: 'Form',
      category: 'Container',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'name', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'submitGoToFlowStepId',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'submitCooldown',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'submitRedirectUrl',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'errorText',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'FormStep',
      category: 'Container',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'stepId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'type',
          fieldType: { enumId: 'StepType', isRequired: false, type: 'Enum' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormSubmitButton',
      category: 'Atomic',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'color',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Colors',
          editingMode: 'Custom',
        },
        {
          id: 'size',
          fieldType: { enumId: 'Sizes', isRequired: true, defaultValue: 'md', type: 'Enum' },
          name: 'Sizes',
          editingMode: 'Custom',
        },
        { id: 'children', fieldType: { isRequired: false, type: 'String' } },
        {
          id: 'outline',
          fieldType: { isRequired: false, type: 'String' },
          name: 'Outline',
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormTextInput',
      category: 'Custom',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'type',
          fieldType: { enumId: 'InputType', isRequired: false, defaultValue: 'text', type: 'Enum' },
          editingMode: 'Custom',
        },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'placeholder',
          fieldType: { isRequired: false, defaultValue: '', type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormSelectInput',
      category: 'Custom',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'placeholder',
          fieldType: { isRequired: false, defaultValue: '', type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'options',
          fieldType: { isRequired: true, type: 'InputOptions' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormTextarea',
      category: 'Custom',
      location: 'Leaf',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'placeholder',
          fieldType: { isRequired: false, defaultValue: '', type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormCheckboxList',
      category: 'Custom',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        { id: 'columns', fieldType: { isRequired: false, type: 'Number' }, editingMode: 'Custom' },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'options',
          fieldType: { isRequired: true, type: 'InputOptions' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormMultiSelectCardGroup',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        { id: 'columns', fieldType: { isRequired: false, type: 'Number' }, editingMode: 'Custom' },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormMultiSelectCard',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'value', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'FormSingleSelectCardGroup',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'formInputId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'formId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'label', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'required',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        { id: 'columns', fieldType: { isRequired: false, type: 'Number' }, editingMode: 'Custom' },
        {
          id: 'showLabel',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        {
          id: 'validation',
          fieldType: { isRequired: false, type: 'InputOptions' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'FormSingleSelectCard',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'value', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'Modal',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'isDismissible',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'Dismissible',
          editingMode: 'Custom',
        },
        {
          id: 'hideBackdrop',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          name: 'HideBackdrop',
          editingMode: 'Custom',
        },
        {
          id: 'horizontalPosition',
          fieldType: { isRequired: true, type: 'String' },
          name: 'horizontalPosition',
          editingMode: 'Custom',
        },
        {
          id: 'verticalPosition',
          fieldType: { isRequired: true, type: 'String' },
          name: 'verticalPosition',
          editingMode: 'Custom',
        },
        { id: 'stateId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        { id: 'width', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'height', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'minWidth', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'minHeight',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'maxWidth', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'maxHeight',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
      ],
      actions: ['OnClick'],
    },
    {
      type: 'Hotspot',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        { id: 'stateId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'placementId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'dismissBehaviour',
          fieldType: {
            enumId: 'DismissBehaviour',
            isRequired: false,
            defaultValue: 'minimize',
            type: 'Enum',
          },
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
      ],
      actions: ['OnClick'],
    },
    {
      type: 'HotspotGroup',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'shouldOpenFirst',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
      ],
    },
    {
      type: 'Tour',
      category: 'Layout',
      location: 'Internal',
      props: [
        { id: 'stateId', fieldType: { isRequired: true, type: 'String' }, editingMode: 'Custom' },
      ],
    },
    {
      type: 'TourStep',
      category: 'Layout',
      location: 'Internal',
      props: [
        {
          id: 'className',
          fieldType: { isRequired: false, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'placementId',
          fieldType: { isRequired: true, type: 'String' },
          editingMode: 'Custom',
        },
        {
          id: 'hasDismiss',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
        { id: 'variant', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        { id: 'groupId', fieldType: { isRequired: false, type: 'String' }, editingMode: 'Custom' },
        {
          id: 'hasBackdrop',
          fieldType: { isRequired: false, defaultValue: false, type: 'Bool' },
          editingMode: 'Custom',
        },
      ],
      actions: ['OnClick'],
    },
    { type: 'Banner', category: 'Layout', location: 'Internal' },
  ],
};
